import { render, staticRenderFns } from "./SingleArticleNote.vue?vue&type=template&id=1339cdbc&scoped=true&lang=pug&"
import script from "./SingleArticleNote.vue?vue&type=script&lang=js&"
export * from "./SingleArticleNote.vue?vue&type=script&lang=js&"
import style0 from "./SingleArticleNote.vue?vue&type=style&index=0&id=1339cdbc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339cdbc",
  null
  
)

/* custom blocks */
import block0 from "./SingleArticleNote.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports